import React, { Component } from "react";
import { connect } from "react-redux";
// core components

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Slide from "@material-ui/core/Slide";
import toastr from "toastr";
import axios from "../../../config/axios";
import SimpleReactValidator from "simple-react-validator";
import { hist } from "../../..";
import { validatePassword } from "../../../utils/validate";
toastr.options = {
  closeButton: true
};
const validationStyle = {
  color: "red"
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    let id = localStorage.getItem("id");
    this.validator = new SimpleReactValidator();
    this.state = {
      id,
      name: "",
      description: "",
      showOldPassword: false,
      showNewPassword: false,
      showConfPassword: false,
      oldPass: "",
      newPass: "",
      confirmPass: ""
    };
  }

  handleClickShowOldPassword = () => {
    this.setState({
      showOldPassword: !this.state.showOldPassword
    });
  };

  handleClickShowNewPassword = () => {
    this.setState({
      showNewPassword: !this.state.showNewPassword
    });
  };

  handleClickShowConfPassword = () => {
    this.setState({
      showConfPassword: !this.state.showConfPassword
    });
  };

  inputHandler = event => {
    const { name, value } = event.target;
    if ((name === "newPass" || name === "confirmPass") && value.length > 20) {
      toastr.error("Max 20 Character Password is allowed!");
    } else {
      this.setState({ [name]: value });
    }
  };

  resetPassword = () => {
    const { newPass, oldPass, confirmPass, id } = this.state;
    if (!oldPass) {
      toastr.error("Please enter old password");
    } else if (!newPass) {
      toastr.error("Please enter new password");
    } else if (!confirmPass) {
      toastr.error("Please confirm password");
    } else if (newPass !== confirmPass) {
      toastr.error("New password and confirm password should match");
    } else {
      let obj = {
        old_password: oldPass,
        new_password: confirmPass
      };

      if (this.validator.allValid()) {
        if (validatePassword(obj.new_password)) {
          axios
            .patch(`admin/users/${id}/reset-password`, obj)
            .then(res => {
              toastr.success(res.data.message);
              this.props.handleClose();
              localStorage.removeItem("adminData");
              localStorage.removeItem("id");
              localStorage.removeItem("email");
              localStorage.removeItem("name");
              hist.push("/admin/pages/login-page");
            })
            .catch(err => {
              toastr.error(err.response.data.message);
            });
        } else {
          toastr.error(
            "Password must be between 12-20 characters</br>Must satisfy any two of four categories</br>1.Contains Uppercase Alphabet(A-Z)</br>2.Contains Lowercase Alphabet(a-z)</br>3.Contains digits(0-9)</br>4.Contains splChars(!@#$%^&*)"
          );
        }
      } else {
        this.validator.showMessages();

        this.forceUpdate();
      }
    }
  };

  render() {
    const { show, handleClose } = this.props;
    const {
      oldPass,
      newPass,
      confirmPass,
      showOldPassword,
      showNewPassword,
      showConfPassword
    } = this.state;
    return (
      <div>
        <Dialog
          maxWidth={"md"}
          open={show}
          onClose={handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              width: "30%"
            }
          }}
        >
          <DialogTitle id="form-dialog-title">Reset Password</DialogTitle>
          <DialogContent style={{ width: "600px", maxWidth: "100%" }}>
            <FormControl fullWidth>
              <InputLabel htmlFor="adornment-password">Old password</InputLabel>
              <Input
                id="adornment-password"
                type={showOldPassword ? "text" : "password"}
                fullWidth
                value={oldPass}
                name="oldPass"
                // onChange={e => {
                //   this.setState({
                //     oldPass: e.target.value
                //   });
                // }}
                onChange={this.inputHandler}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowOldPassword}
                    >
                      {showOldPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: "15px" }}>
              <InputLabel htmlFor="adornment-password">New password</InputLabel>
              <Input
                id="adornment-password"
                type={showNewPassword ? "text" : "password"}
                fullWidth
                name="newPass"
                value={newPass}
                // onChange={e => {
                //   if(e.target.value.length>20){
                //     toastr.error("Max 20 Character Password is allowed!");
                //   }else{
                //   this.setState({
                //     newPass: e.target.value
                //   });
                //   }
                // }}
                onChange={this.inputHandler}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowNewPassword}
                    >
                      {showNewPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {
                <span style={validationStyle}>
                  {this.validator.message(
                    "Password",
                    newPass,
                    "required|min:12"
                  )}
                </span>
              }
            </FormControl>
            <FormControl fullWidth style={{ marginTop: "15px" }}>
              <InputLabel htmlFor="adornment-password">
                Confirm password
              </InputLabel>
              <Input
                id="adornment-password"
                type={showConfPassword ? "text" : "password"}
                fullWidth
                name="confirmPass"
                value={confirmPass}
                // onChange={e => {
                //   this.setState({
                //     confirmPass: e.target.value
                //   });
                // }}
                onChange={this.inputHandler}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowConfPassword}
                    >
                      {showConfPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {
                <span style={validationStyle}>
                  {this.validator.message(
                    "Password",
                    confirmPass,
                    "required|min:12"
                  )}
                </span>
              }
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.resetPassword}
            >
              Reset
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // logout: () => dispatch(logout())
  };
};

export default connect(null, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/Common/FevoModels/ResetPassword.jsx